<div class="passive" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
  <mat-icon [svgIcon]="icon()" color="accent"></mat-icon>
  <div fxLayout="column">
    @if (entityName()) {
      <span class="secondary overflow-hidden text-ellipsis whitespace-nowrap" fxLayoutAlign="start center">
        {{ entityName() }}
      </span>
    }
    @if (name()) {
      <span class="main overflow-hidden text-ellipsis whitespace-nowrap" fxLayoutAlign="start center">{{ name() | translate }}</span>
    }
  </div>
</div>
